import { Component, HostBinding, HostListener, inject, Input } from '@angular/core';
import { ADMIN_TABLE, AdminTableSortHost } from './admin-table.token';
import { AdminTableIconComponent } from './table-icon.component';

/**
 * `<th adminSort="field">Label</th>` inside an admin-table header template.
 * (`&ngsp;` keeps the space between label and icon that PrimeNG's markup had.)
 * Click (or Enter) sorts by the field, toggling ascending/descending.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- used as an attribute on <th>
  selector: 'th[adminSort]',
  standalone: true,
  imports: [AdminTableIconComponent],
  template: `<ng-content></ng-content>&ngsp;<admin-table-icon class="admin-sort-icon" [name]="icon"></admin-table-icon>`,
})
export class AdminSortHeaderComponent {
  private readonly table: AdminTableSortHost = inject(ADMIN_TABLE);

  @Input({ required: true }) adminSort!: string;

  @HostBinding('class.admin-sortable') readonly sortable = true;
  @HostBinding('attr.tabindex') readonly tabindex = 0;

  @HostBinding('class.admin-sorted')
  get sorted(): boolean {
    return this.table.sortField === this.adminSort;
  }

  @HostBinding('attr.aria-sort')
  get ariaSort(): string {
    return this.sorted ? (this.table.sortDir === 'asc' ? 'ascending' : 'descending') : 'none';
  }

  get icon() {
    return !this.sorted ? 'sortAlt' : this.table.sortDir === 'asc' ? 'sortAmountUpAlt' : 'sortAmountDown';
  }

  @HostListener('click')
  @HostListener('keydown.enter')
  toggle(): void {
    this.table.sortBy(this.adminSort);
  }
}
